import { render } from "./ThinkingSkillList.vue?vue&type=template&id=63b32ab8"
import script from "./ThinkingSkillList.vue?vue&type=script&lang=js"
export * from "./ThinkingSkillList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__